import { Outlet } from "react-router-dom";

export default function WebsiteLayout() {
    return (
        <Outlet />
    )
}